import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useMultiStepForm } from "../MultiStepFormContext";
import { getQuestionsForService, SERVICE_PATHS } from "../questionConfig";
import { QuestionRenderer } from "../questions";

export function ProjectDetailsStep() {
  const { serviceType, answers, setAnswer } = useMultiStepForm();

  if (!serviceType) {
    return null;
  }

  const questions = getQuestionsForService(serviceType);
  const servicePath = SERVICE_PATHS.find((p) => p.id === serviceType);

  // Get step title based on service type
  const getStepTitle = () => {
    switch (serviceType) {
      case "project":
        return "Tell us about your project";
      case "partnership":
        return "Partnership details";
      case "consultation":
        return "What do you need help with?";
      case "general":
        return "Your message";
      default:
        return "Project details";
    }
  };

  return (
    <div className="space-y-8">
      <div className="text-center">
        <div className="flex items-center justify-center gap-2 mb-2">
          {servicePath && (
            <servicePath.icon className="w-4 h-4 text-[var(--dug-coral)]" />
          )}
          <span className="text-sm font-medium text-[var(--dug-coral)]">
            {servicePath?.title}
          </span>
        </div>
        <h2 className="text-[var(--dug-text-primary)] ds-type-control-heading">
          {getStepTitle()}
        </h2>
      </div>

      <div className="space-y-8">
        <AnimatePresence mode="popLayout">
          {questions.map((question, index) => (
            <motion.div
              key={question.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ delay: index * 0.1 }}
            >
              <QuestionRenderer
                question={question}
                value={answers[question.id]}
                onChange={(value) => setAnswer(question.id, value)}
              />
            </motion.div>
          ))}
        </AnimatePresence>
      </div>

      {/* Progress dots */}
      <div className="flex justify-center gap-2 pt-4">
        {questions.map((q) => {
          const isAnswered = answers[q.id] !== undefined && answers[q.id] !== "";
          return (
            <div
              key={q.id}
              className={`
                w-2 h-2 rounded-full transition-colors
                ${isAnswered
                  ? "bg-[var(--dug-coral)]"
                  : "bg-[var(--dug-border)]"
                }
              `}
            />
          );
        })}
      </div>
    </div>
  );
}
